import get from "lodash.get"
import dayjs from "dayjs"

import {
	getPremiumBeforeDiscounts,
	getDiscounts
} from "@/modules/reports/schemas/utils/"

const schema = [
	{ label: "Quote Number", data: item => item.id },
	{ label: "Client", data: item => get(item, "holder.name") },
	{ label: "Client Type", data: item => get(item, "holder.__typename") },
	{
		label: "Email",
		data: item =>
			get(item, "holder.contacts")
				? item.holder.contacts
						.filter(item => item.type === "email")
						.map(item => item.value)
				: ""
	},
	{
		label: "Insurance Type",
		data: item => get(item, "acceptedOffer.product.productId.type")
	},
	{
		label: "Product",
		data: item => get(item, "acceptedOfferproduct.name")
	},
	{
		label: "Insurer",
		data: item => get(item, "acceptedOffer.product.insurer.name")
	},
	//TODO: get optional benefit from right place
	// {
	// 	label: "Optional benefits",
	// 	data: item => getOptionalBenefits(item.product)
	// },
	{
		label: "Premium before discounts",
		data: item =>
			item.acceptedOffer
				? getPremiumBeforeDiscounts(item.acceptedOffer.premium)
				: ""
	},
	{
		label: "Premium after discounts",
		data: item =>
			get(item, "acceptedOffer") ? item.acceptedOffer.premium.amount : ""
	},
	{
		label: "Applied discounts",
		data: item => getDiscounts(item)
	},
	{
		label: "Currency",
		data: item =>
			get(item, "acceptedOffer") ? item.acceptedOffer.premium.currencyCode : ""
	},
	{ label: "Status", data: item => get(item, "status") },
	{
		label: "Rejection Codes",
		data: item =>
			item.rejectionCodes ? item.rejectionCodes.map(item => item.name) : ""
	},
	{
		label: "Rejection Remarks",
		data: item => get(item, "rejectionRemarks", "")
	},
	{
		label: "Rejected by",
		data: item => get(item, "rejectedBy.username", "")
	},
	{ label: "Referral", data: item => get(item, "referrer.name") },
	{ label: "Source", data: item => item.source },
	{
		label: "Start Date",
		data: item =>
			item.startDate ? dayjs(item.startDate).format("DD/MM/YYYY") : null
	},
	{
		label: "End Date",
		data: item =>
			item.endDate ? dayjs(item.endDate).format("DD/MM/YYYY") : null
	},
	{
		label: "Created",
		data: item =>
			item.createdAt ? dayjs(item.createdAt).format("DD/MM/YYYY") : null
	}
]

export default {
	quotes: [...schema]
}
